<template>
  <a-layout>
    <a-layout-header :style="{ position: 'fixed', zIndex: 9, width: '100%' }">
      <div class="w1200" style="display: flex; align-items: center; height: 100%; position: relative">
        <router-link to="/index" @click="selectIndex">
          <img src="../assets/images/logo.png" alt="" class="logo" />
        </router-link>
        <a-row align="middle" justify="space-between" style="width: 100%; height: 100%">
          <a-col :span="16">
            <a-menu :openKeys="openKeys" :selectedKeys="selectedKeys" @click="select" mode="horizontal"
              v-if="isSearch == 0">
              <template v-for="item in headMenuList" :key="item.key">
                <template v-if="!item.children">
                  <a-menu-item :key="item.name">
                    <a :href="item.path" target="_blank" v-if="item.href">{{ item.title }}</a>
                    <router-link :to="item.path" v-else>{{ item.title }}</router-link>
                  </a-menu-item>
                </template>
                <template v-else>
                  <a-sub-menu :key="item.name">
                    <template #title>{{ item.title }}</template>
                    <a-menu-item v-for="submenu in item.children" :key="submenu.name">
                      <router-link :to="submenu.path">{{ submenu.title }}</router-link>
                    </a-menu-item>
                  </a-sub-menu>
                </template>
              </template>
              <!-- <a-menu-item key="/index">
                <router-link to="/index">跨境商学院</router-link>
              </a-menu-item>
              <a-menu-item key="convoy">
                <a href="https://yinolink.com/convoy" target="_blank">护航计划</a>
              </a-menu-item>
              <a-sub-menu key="sub1">
                <template #title>线上课堂</template>
                <a-menu-item key="/courseList">
                  <router-link to="/courseList">系列课程</router-link>
                </a-menu-item>
                <a-menu-item key="/liveList">
                  <router-link to="/liveList">周五直播</router-link>
                </a-menu-item>
              </a-sub-menu>
              <a-menu-item key="/offlineList">
                <router-link to="/offlineList">线下活动</router-link>
              </a-menu-item>
              <a-menu-item key="/articleList">
                <router-link to="/articleList">营销干货</router-link>
              </a-menu-item>
              <a-menu-item key="/whiteBookList">
                <router-link to="/whiteBookList">行业报告</router-link>
              </a-menu-item> -->
            </a-menu>
            <transition appear name="animate__animated animate__bounce" enter-active-class="animate__bounceInDown"
              leave-active-class="animate__bounceOutDown" v-else>
              <a-input ref="searchRef" v-model:value.trim="searchValue" :bordered="false" allow-clear
                @keyup.enter.native="searchResult" @change="searchChange" placeholder="请输入您要搜索的内容">
                <template #prefix>
                  <i class="iconfont icon-zwsousuo"></i>
                </template>
              </a-input>
            </transition>
          </a-col>
          <a-col :span="8" style="text-align: right">
            <div>
              <span v-if="isSearch == 0" @click="searchBtn">
                <i class="iconfont icon-zwsousuo"></i>
                <span class="search">搜索</span>
              </span>
              <span v-else>
                <i class="iconfont icon-zwguanbi" @click="closeSearchBtn"></i>
                <span class="search" @click="searchResult">搜索</span>
              </span>

              <a-divider style="border-color: rgba(0, 0, 0, 0.25)" type="vertical" />
              <span class="Title myInfo" style="margin-right: 16px" @click="goMyLearn">学习记录</span>
              <span class="Title myInfo" style="margin-right: 16px" @click="goMyBuy">我的已购</span>
              <a-button type="primary" ghost @click="login" v-if="userInfo == null">登录</a-button>

              <div class="dropdownBox" style="display: inline-block" v-if="userInfo != null">
                <a-dropdown placement="bottom" overlayClassName="dropdownContent" :overlayStyle="{
                  width: '250px',
                  height: '260px',
                  backgroundColor: ' #fff',
                  borderRadius: '8px',
                  boxShadow: '0px 2px 8px 2px rgba(0,0,0,0.06)',
                  padding: '20px',
                }">
                  <a-avatar :size="32" :src="head_img">
                    <template #icon>
                      <UserOutlined />
                    </template>
                  </a-avatar>
                  <template #overlay>
                    <div>
                      <a-avatar :size="32" :src="head_img">
                        <template #icon>
                          <UserOutlined />
                        </template>
                      </a-avatar>
                      <span class="userName">{{ userInfo.name }}</span>
                      <a-divider style="background-color: #ebebeb; margin: 16px 0" />
                      <div class="learn">
                        <div class="left">
                          <span class="time">{{ studyTime.time }}</span>
                          <span class="timeType">今日学习（分钟）</span>
                        </div>
                        <a-divider type="vertical" style="height: 50px; border-color: rgba(0, 0, 0, 0.25)" />
                        <div class="right">
                          <span class="time">{{ studyTime.date }}</span>
                          <span class="timeType">累计学习（天）</span>
                        </div>
                      </div>
                      <router-link to="/myCenter">
                        <div class="personal">
                          <div style="display: flex; align-items: center">
                            <img src="../assets/images/icon_personal.png" alt="" />
                            <span>个人中心</span>
                          </div>
                          <img src="../assets/images/index_rightArrow.png" alt="" />
                        </div>
                      </router-link>
                      <a-button type="primary" ghost block @click="logout">退出登录</a-button>
                    </div>
                  </template>
                </a-dropdown>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </a-layout-header>
    <a-layout-content id="commonContent" :style="{ padding: '80px 0 40px' }">
      <router-view />
      <div class="AffixBox">
        <ul>
          <a-tooltip placement="left" overlayClassName="serverWX" @visibleChange="showQr" arrow-point-at-center>
            <template #title>
              <!-- <img src="@/assets/images/YLConsult.jpg" alt="" style="width: 100px; height: 100px" /> -->
              <div>
                <div class="serviceBox">
                  添加企业微信<br />
                  为您提供1对1的专业解答
                </div>
                <div id="wl-qrcode1" style="width: 120px; height: 120px; margin: 0 auto"></div>
              </div>
            </template>
            <li>
              <i class="iconfont icon-zwliaotian"></i>
              <span>咨询</span>
            </li>
          </a-tooltip>

          <li @click="goTop">
            <VerticalAlignTopOutlined style="font-size: 22px; color: #3A84FF" />
            <span>置顶</span>
          </li>
        </ul>
      </div>
    </a-layout-content>
    <a-layout-footer>
      <div class="w1200">
        <a-row>
          <a-col :span="6">
            <img src="../assets/images/footer_logo.png" alt="" class="footerLogo" />
            <h3 class="leftTitle">专注海外营销领域知识输出</h3>
            <div class="footerQrcode">
              <div class="qrcodeItem">
                <a-popover>
                  <template #content>
                    <img src="@/assets/images/friday_qrcode.png" alt="" style="width: 90px;height: 90px;">
                  </template>
                  <span>
                    <div></div>
                    <img src="@/assets/images/wechat.svg" alt="">
                    <img src="@/assets/images/wechat-active.svg" alt="" style="display: none">
                  </span>
                  <p>公众号</p>
                </a-popover>
              </div>
              <div class="qrcodeItem">
                <a-popover>
                  <template #content>
                    <img src="@/assets/images/mobile_qr.jpeg" alt="" style="width: 90px;height: 90px;">
                  </template>
                  <span>
                    <div></div>
                    <img src="@/assets/images/miniprogram.svg" alt="">
                    <img src="@/assets/images/miniprogram-active.svg" alt="" style="display: none">
                  </span>
                  <p>小程序</p>
                </a-popover>

              </div>
            </div>
          </a-col>
          <a-col :span="6">
            <h3 class="title">服务内容</h3>
            <ul class="footNav">
              <li v-for="item in serveMenu" :key="item.index">
                <a :href="item.href" target="_blank"><span>{{ item.title }}</span></a>
              </li>
            </ul>
          </a-col>
          <a-col :span="6">
            <h3 class="title">关于YinoLink</h3>
            <ul class="footNav">
              <li v-for="item in aboutMenu" :key="item.index">
                <a :href="item.href" target="_blank"><span>{{ item.title }}</span></a>
              </li>
            </ul>
          </a-col>
          <a-col :span="6">
            <h3 class="title">周5出海</h3>
            <ul class="footNav">
              <li v-for="item in zhouwuMenu" :key="item.index">
                <router-link :to="item.href"><span>{{ item.title }}</span></router-link>
              </li>
            </ul>
          </a-col>
        </a-row>
        <a-divider style="margin: 40px 0; border-color: #ebebeb" />
        <div class="footer_file" @click="goBeiAn">
          <span>©2025杭州几海里网络科技有限公司</span>
          <span><img src="../assets/images/footer_file.png" alt="" />浙公网安备 33010902002456号</span>
          <span>浙ICP备2025175357号-1</span>
        </div>
      </div>
    </a-layout-footer>
  </a-layout>

  <!-- 登陆框 -->
  <Login />
  <!-- 微信登陆手机绑定框 -->
  <BindPhoneDialog />
</template>

<script>
import 'animate.css'
import { UserOutlined, VerticalAlignTopOutlined } from '@ant-design/icons-vue'
import Login from './Login.vue'
import BindPhoneDialog from './BindPhoneDialog.vue'

export default {
  name: 'Home',
  components: { UserOutlined, VerticalAlignTopOutlined, Login, BindPhoneDialog },
  data() {
    return {
      userInfo: null,
      head_img: '',
      isLogin: 1,
      isSearch: 0,
      searchValue: '',
      openKeys: [this.$route.path],
      selectedKeys: [this.$route.path],
      headMenuList: [
        {
          title: '跨境商学院',
          name: '/index',
          path: '/index',
        },
        // {
        //   title: '护航计划',
        //   name: '/convoy',
        //   path: 'https://yinolink.com/convoy',
        //   href: true,
        // },
        {
          title: '线上课堂',
          name: '/',
          path: '/',
          children: [
            {
              title: '系列课程',
              name: '/courseList',
              path: '/courseList',
            },
            {
              title: '周五直播',
              name: '/liveList',
              path: '/liveList',
            },
          ],
        },
        {
          title: '线下活动',
          name: '/offlineList',
          path: '/offlineList',
        },
        {
          title: '营销干货',
          name: '/articleList',
          path: '/articleList',
        },
        {
          title: '行业报告',
          name: '/whiteBookList',
          path: '/whiteBookList',
        },
        {
          title: '营销服务',
          name: '/serviceList',
          path: '/serviceList',
        },
        {
          title: 'YinoCloud',
          name: 'YinoCloud',
          path: 'https://yinocloud.yinolink.com/?source=zhou5chuhai',
          href: true
        },
      ],
      // 底部导航数据
      serveMenu: [
        {
          href: 'https://yinolink.com/advertising/',
          title: '自助广告管理系统',
        },
        {
          href: 'https://yinolink.com/promotion/',
          title: '全渠道海外广告代投',
        },
        {
          href: 'https://yinolink.com/academy/',
          title: '海外营销培训',
        },
        {
          href: 'https://yinocloud.yinolink.com/?source=zhou5',
          title: 'YinoCloud',
        },
        {
          href: 'https://yinolink.com/dtc_gem/?source=zhou5',
          title: 'DTC独立站Meta广告陪跑服务',
        }
      ],
      aboutMenu: [
        {
          href: 'https://yinolink.com/aboutus',
          title: '关于我们',
        },
        {
          href: 'https://yinolink.com/blog',
          title: '新闻资讯',
        },
        {
          href: 'https://yinolink.com/contact',
          title: '联系我们',
        },
        {
          href: 'https://yinolink.com/case',
          title: '成功案例',
        },
        {
          href: 'https://yinolink.com/joinIn',
          title: '加入我们',
        },
        {
          href: 'https://yinolink.com/help',
          title: '常见问题',
        },
      ],
      zhouwuMenu: [
        {
          href: '/articleList',
          title: '营销干货',
        },
        {
          href: '/whiteBookList',
          title: '行业报告',
        },
        {
          href: '/liveList',
          title: '周5直播',
        },
        {
          href: '/offlineList',
          title: '线下活动',
        },
        {
          href: '/courseList',
          title: '系列课程',
        },
      ],
      studyTime: {},
    }
  },
  watch: {
    $route(to, from) {
      this.showQr()
      if (to.path == '/index') {
        document.getElementById('commonContent').setAttribute('style', 'padding:80px 0 0')
      } else {
        document.getElementById('commonContent').setAttribute('style', 'padding:80px 0 40px')
      }
    },
  },
  mounted() {
    this.showQr()
    // 获取localStorage中的用户信息
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    if (this.userInfo != null) {
      this.head_img = this.userInfo.w_headimgurl
    }
    this.getStudyTime()
  },
  methods: {
    async showQr() {
      setTimeout(() => {
        ['wl-qrcode1', 'wl-qrcode2'].forEach((elementId) => {
          // console.log(document.getElementById(elementId))
          // if (document.getElementById(elementId)) console.log(document.getElementById(elementId).getElementsByTagName('img').length)
          if (document.getElementById(elementId) && !document.getElementById(elementId).getElementsByTagName('img').length) {
            (function () {
              console.log(elementId, document.getElementById(elementId), document.getElementById(elementId).getElementsByTagName('img').length)
              let wl = document.createElement("script");
              wl.type = "text/javascript";
              wl.src = "https://material.weiling.cn/h5/willing-third-party-js/v1/qrcode-nostyle-comp-v1.min.js"
              wl.id = `wlQRNS-${elementId}`;
              wl.onload = function () {
                wlQrcodeNostyleComp.init({
                  wl_id: "wpW2WmDAAAjT9PP65h63Ilm7Xlbvg4qg", //  [修改1：将wl_id粘贴至此]
                  wl_qrcode_id: elementId === 'wl-qrcode1' ? ['1595679447984668672'] : ['1595679673638019072'], // [修改2：将wl_qrcode_id粘贴至此]
                  DOMid: [elementId], // 插入处div标签的id
                });
                console.log('init')
              };
              if (!document.getElementById("wlQRNS")) {
                let s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(wl, s);
              }
            })();
          }
        })
      }, 100)
      // setTimeout(() => {
      //   (function () {
      //     let wl = document.createElement("script");
      //     wl.type = "text/javascript";
      //     wl.src = "https://material.weiling.cn/h5/willing-third-party-js/v1/qrcode-nostyle-comp-v1.min.js"
      //     wl.id = "wlQRNS";
      //     wl.onload = function () {
      //       wlQrcodeNostyleComp.init({
      //         wl_id: "wpW2WmDAAAjT9PP65h63Ilm7Xlbvg4qg", //  [修改1：将wl_id粘贴至此]
      //         wl_qrcode_id: ['1595679447984668672', "1595679673638019072"], // [修改2：将wl_qrcode_id粘贴至此]
      //         DOMid: ["wl-qrcode1", 'wl-qrcode2'], // 插入处div标签的id
      //       });
      //     };
      //     if (!document.getElementById("wlQRNS")) {
      //       let s = document.getElementsByTagName("script")[0];
      //       s.parentNode.insertBefore(wl, s);
      //     }
      //   })();
      //   console.log(document.getElementById('wl-qrcode1'))
      // }, 100)
    },
    async getStudyTime() {
      const { data: res } = await this.$http.post('index/study')
      this.studyTime = res.data

      if (this.$route.query.keywords != undefined) {
        this.searchValue = this.$route.query.keywords
        this.isSearch = 1
        // this.searchResult()
        this.$nextTick(() => {
          this.$refs.searchRef.focus()
        })
      }
    },
    select({ key }) {
      this.openKeys = [key]
      this.selectedKeys = [key]
    },
    selectIndex() {
      this.openKeys = ['/index']
      this.selectedKeys = ['/index']
    },
    searchChange() {
      if (this.searchValue == '') {
        this.$router.replace({ query: {} })
      }
    },
    searchBtn() {
      this.isSearch = 1
    },
    closeSearchBtn() {
      this.searchValue = ''
      this.isSearch = 0
      this.$router.replace({ query: {} })
    },
    searchResult() {
      if (this.searchValue == '') {
        return this.$message.warning('请输入您要搜索的内容')
      } else if (this.searchValue == this.$route.query.keywords) {
        return this.$message.warning('输入的内容无变化')
      }
      this.$router.push({
        name: 'SearchList',
        query: {
          keywords: this.searchValue,
        },
      })
    },
    goMyLearn() {
      if (this.userInfo == null) {
        this.$bus.emit('openLogin')
      } else {
        this.$router.push('/myCenter/myCourse')
      }
    },
    goMyBuy() {
      if (this.userInfo == null) {
        this.$bus.emit('openLogin')
      } else {
        this.$router.push('/myCenter/myOrder/orderTotal')
      }
    },
    login() {
      this.$bus.emit('openLogin')
    },
    logout() {
      window.localStorage.clear()
      location.reload()
    },
    goTop() {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    },
    goBeiAn() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    getPopupContainer(triggerNode) {
      console.log(triggerNode);
    }
  },
}
</script>

<style lang="less" scoped>
:deep(.ant-menu) {
  color: rgba(0, 0, 0, 0.65);
}

.ant-layout {
  overflow: auto;
}

.ant-layout-header {
  height: 80px;
  background-color: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);

  .logo {
    width: 154px;
    height: 55px;
    margin-right: 32px;
  }

  .ant-menu-horizontal {
    line-height: 46px !important;
    border-bottom: none;
  }

  :deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item) {
    padding: 0 8px;
  }

  :deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item a) {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
  }

  :deep(.ant-menu-horizontal > .ant-menu-item-selected a) {
    color: #3A84FF !important;
  }

  :deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu) {
    padding: 0 8px;
  }

  .iconfont.icon-zwsousuo,
  .iconfont.icon-zwguanbi {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
    margin-right: 4px;
  }

  .search {
    cursor: pointer;
  }

  .Title.myInfo {
    cursor: pointer;
  }
}

.userName {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  margin-left: 16px;
}

.learn {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .left,
  .right {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .time {
      font-size: 22px;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 8px;
    }

    .timeType {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
    }
  }
}

.personal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  span {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
  }
}

.ant-layout-content {
  background-color: #fafafa;
}

.ant-layout-footer {
  background-color: #fff;
  box-shadow: 0px 2px 4px 2px rgba(0, 0, 0, 0.06);
  padding-top: 0;

  .footerLogo {
    width: 193px;
    height: 69px;
    margin: 48px 0 40px;
  }

  .footerQrcode {
    width: 100%;
    display: flex;
    align-items: center;

    .qrcodeItem {
      float: left;
      margin-right: 20px;
      margin-top: 17px;
      text-align: center;
      cursor: pointer;

      span {
        display: block;
        width: 64px;
        height: 40px;
        background: #eff1f8;
        border-radius: 8px;
        font-size: 22px;
        transition: all .2s;
        position: relative;

        div {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 22px;
          height: 22px;
          background-color: #fff;
          border-radius: 50%;
        }

        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 24px;
          height: 24px;
        }

        &:hover {
          background: #3A84FF;
        }

        &:hover img:nth-child(1) {
          display: none;
        }

        &:hover img:last-child {
          display: block !important;
        }
      }

      p {
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
  }

  .title {
    font-weight: bold;
    margin: 68px 0 32px;
  }

  .leftTitle {
    color: rgba(0, 0, 0, 0.65);
  }

  .footNav {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      width: 50%;
      margin-bottom: 20px;

      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  .footer_file {
    text-align: center;
    cursor: pointer;

    span {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      margin-right: 20px;

      img {
        width: 14px;
        height: 14px;
      }
    }
  }
}

.AffixBox {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;

  ul {
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 68px;
      height: 68px;
      border-radius: 4px;
      background-color: #fff;
      box-shadow: 0 14px 36px rgba(0, 0, 0, 6%);
      margin-bottom: 8px;
      padding: 20px;
      cursor: pointer;

      .iconfont {
        font-size: 20px;
        color: #3A84FF;
      }

      span {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}
</style>
